import React, { useEffect, useState } from 'react';
import { useApp } from '../context/AppContext';
import * as api from '../services/api';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { toast } from 'sonner';

const SiteManager = () => {
  const { siteSettings, fetchSiteSettings } = useApp();
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState({
    nama_perusahaan: '',
    alamat: '',
    no_hp: '',
    logo: null
  });

  useEffect(() => {
    if (siteSettings) {
      setForm((prev) => ({
        ...prev,
        nama_perusahaan: siteSettings.nama_perusahaan || '',
        alamat: siteSettings.alamat || '',
        no_hp: siteSettings.no_hp || ''
      }));
    }
  }, [siteSettings]);

  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async () => {
    if (!form.nama_perusahaan.trim()) {
      toast.error('Nama perusahaan wajib diisi');
      return;
    }

    setSaving(true);
    try {
      const data = new FormData();
      data.append('nama_perusahaan', form.nama_perusahaan);
      data.append('alamat', form.alamat || '');
      data.append('no_hp', form.no_hp || '');
      if (form.logo) data.append('logo', form.logo);

      await api.updateSiteSettings(data);
      await fetchSiteSettings();
      toast.success('Site Manager berhasil disimpan');
      setForm((prev) => ({ ...prev, logo: null }));
    } catch (error) {
      toast.error('Gagal menyimpan Site Manager');
      console.error(error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-6" data-testid="site-manager-page">
      <div>
        <h1 className="text-3xl font-black tracking-tight">Site Manager</h1>
        <p className="text-muted-foreground text-sm mt-1">Pengaturan informasi perusahaan dan logo</p>
      </div>

      <Card className="bg-white border border-border/60">
        <CardHeader>
          <CardTitle>Profil Perusahaan</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="space-y-2">
            <Label>Nama Perusahaan</Label>
            <Input
              value={form.nama_perusahaan}
              onChange={(e) => handleChange('nama_perusahaan', e.target.value)}
              placeholder="Nama perusahaan"
            />
          </div>
          <div className="space-y-2">
            <Label>Alamat</Label>
            <Input
              value={form.alamat}
              onChange={(e) => handleChange('alamat', e.target.value)}
              placeholder="Alamat perusahaan"
            />
          </div>
          <div className="space-y-2">
            <Label>No HP</Label>
            <Input
              value={form.no_hp}
              onChange={(e) => handleChange('no_hp', e.target.value)}
              placeholder="Nomor HP perusahaan"
            />
          </div>
          <div className="space-y-2">
            <Label>Logo Perusahaan</Label>
            <Input
              type="file"
              accept="image/*"
              onChange={(e) => handleChange('logo', e.target.files?.[0] || null)}
            />
            {siteSettings?.logo_url && (
              <div className="mt-2">
                <img
                  src={siteSettings.logo_url}
                  alt="Logo"
                  className="h-16 object-contain"
                />
              </div>
            )}
          </div>
          <div>
            <Button onClick={handleSubmit} disabled={saving}>
              {saving ? 'Menyimpan...' : 'Simpan'}
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SiteManager;
